import { render, staticRenderFns } from "./PassQuestionnaireReviewDialog.vue?vue&type=template&id=7b61fab1&scoped=true"
import script from "./PassQuestionnaireReviewDialog.vue?vue&type=script&lang=js"
export * from "./PassQuestionnaireReviewDialog.vue?vue&type=script&lang=js"
import style0 from "./PassQuestionnaireReviewDialog.vue?vue&type=style&index=0&id=7b61fab1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b61fab1",
  null
  
)

export default component.exports